import script from "./TraitShopConnect.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopConnect.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopConnect.vue?vue&type=style&index=0&id=963e83fa&lang=scss"

const __exports__ = script;

export default __exports__